<div class="toggle">
  @if ((label && label.length) || (tooltipText && tooltipText.length)) {
    <div class="toggle-label-group">
      @if (label && label.length) {
        <div class="toggle-label">
          {{ label }}
        </div>
      }
      @if (tooltipText && tooltipText.length) {
        <fa-icon
          class="info toggle-icon"
          [icon]="faInfoCircle"
          [andorTooltip]="tooltipText"
          [tooltipPosition]="tooltipDirection"></fa-icon>
      }
    </div>
  }
  <ng-content></ng-content>
</div>
